<script>
import ToggleMixin from './mixins/toggle';
import SortTaxonsMixin from './mixins/sort-taxons';

export default {
  name: 'TaxonNestedListItem',
  props: ['taxon'],
  mixins: [ToggleMixin, SortTaxonsMixin],
  computed: {
    children() {
      return this.sortTaxons(this.taxon.taxons);
    },
  },
};
</script>

<template>
  <li
    class="hover:bg-gray-diagomics-light relative"
    @mouseover="showChildren"
    @mouseleave="hideChildren"
  >
    <router-link
      :to="{
        name: `category${uppercaseLocale}`,
        params: { taxonPermalink: taxon.permalink },
        query: { ...$route.query, page: 1 }
      }"
      class="w-full relative block p-2"
    >
      {{ taxon.valid_name }}
      <span v-if="children.length > 0" class="absolute text-gray-300 right-2">
        <i class="fa fa-caret-right"></i>
      </span>
    </router-link>
    <ul v-if="childrenDisplayed && children.length > 0"
        class="w-64 absolute z-20 bg-white top-0 left-32 xl:left-44 top-0 border p-2 shadow-xl
        rounded-r-md rounded-b-md">
      <li
        is="TaxonNestedListItem"
        :taxon="childTaxon"
        v-for="childTaxon in children"
        :key="childTaxon.id"
      />
    </ul>
  </li>
</template>
